export const needsChrId = (contact) => {
    var needsChr = false;
    if (contact.status === 'Inactive' || contact.account.legalName === "Unassigned") {
        return needsChr;
    }
    if (contact.chr || contact.notify) {
        if (contact.chrId === null || contact.chrId === "") {
            needsChr = true;
        }
    }
    return needsChr;
};